const indonesiaWords = {
  //general
  back: "Kembali",
  delete: "Hapus",
  new_data: "Tambah",
  upload: "Upload",
  reset_data: "Pulihkan",
  update_data: "Ubah",
  save_data: "Simpan",
  filter_show: "Filter Lainnya",
  filter_hide: "Sembunyikan Filter",
  filter_clear: "Kosongkan Filter",
  load_more: "Tampilkan Lebih",
  please_complete_data: "Harap lengkapi data!",
  data_not_complete: "Data tidak lengkap",
  minimum_3_characters: "Minimal 3 karakter",
  maximum_character_length: "Panjang karakter maksimal",
  reset_form: "Pulihkan",
  search_data: "Cari",
  data_status_all: "Semua Status",
  data_status_active: "Aktif",
  data_status_inactive: "Inaktif",
  delete_alert: "Hapus data diproses, apakah anda yakin ?",
  activate_alert: "Data ini akan diaktifkan kembali. Apakah Anda yakin?",
  deactivate_alert: "Data ini akan dinonaktifkan. Apakah Anda yakin?",
  confirmation: "Konfirmasi",
  yes: "Iya",
  no: "Tidak",
  cancel: "Batal",
  err_msg_500: "Terjadi kesalahan, mohon coba lagi dalam beberapa saat",
  no_data_found: "Data tidak ditemukan",
  new_password: "Password baru",
  current_password: "Password lama",
  confirm_password: "Konfirmasi password",
  old_password: "Password lama",
  printButtonLabel: "Cetak",
  floating_chat_title: "Halo, ada yang bisa kami bantu?",
  back_to_tms_warning: "Anda akan kembali ke TMS. Apakah Anda yakin?",
  show_detail: "Tampilkan Detail",
  floating_chat_tooltip: "Hai, saya Esti, asisten AI Anda",
  floating_chat_tooltip_sub: "Ada yang bisa saya bantu?",
  session_expired: "Sesi Anda telah berakhir, silahkan login kembali",

  //general word (becareful when you want to change the value)
  word_created_date: "Tanggal Pembuatan",
  word_transport_type: "Tipe Transportasi",
  word_load_type: "Tipe Muatan",
  word_vehicle_type: "Tipe Kendaraan",
  word_name: "Nama",
  word_action: "Aksi",
  word_choose: "Pilih",
  from_date: "Dari tanggal",
  to_date: "Sampai tanggal",
  has_been_added: "telah ditambahkan",
  has_been_updated: "telah diubah",
  has_been_deleted: "telah dihapus",
  has_been_activated: "telah diaktifkan",
  has_been_deactivated: "telah dinonaktifkan",
  delete_success: "Sukses Menonaktifkan Data",
  delete_failed: "Gagal Menonaktifkan Data",
  activate_success: "Sukses Mengaktifkan Data",
  activate_failed: "Gagal Mengaktifkan Data",
  fetch_success: "Sukses Memperbarui Data",
  notification: "Pemberitahuan",
  notification_setting: "Pengaturan Notifikasi",
  table_no_data_found: "Data tidak tersedia",
  invalid: "Tidak Valid",

  no_data: "Tidak Ada Data",
  no_notification: "Tidak ditemukan notifikasi",

  //user
  user_setting_title: "Pengaturan Akun",
  user_data_title: "Informasi Personal",
  company_data_title: "Informasi Perusahaan",
  user_changepassword_title: "Ubah Password",
  user_form_firstname: "Nama Depan",
  user_form_lastname: "Nama Belakang",
  user_form_company: "Perusahaan",
  user_form_country: "Kota",
  user_form_postal_code: "Kode Pos",
  user_form_province: "Provinsi",
  user_form_email: "Email",
  user_form_phone: "Nomor Telepon",
  user_form_mobile_phone: "Nomor Telepon",
  user_form_address: "Alamat",
  user_form_oldpassword: "Password Lama",
  user_form_newpassword: "Password Baru",
  user_form_confirmpassword: "Konfirmasi Password",
  user_form_confirmpasswordwarning: "Password tidak sesuai!",

  user_placeholder_firstname: "Nama depan",
  user_placeholder_lastname: "Nama belakang",
  user_placeholder_company: "Nama perusahaan",
  user_placeholder_email: "EMAIL",
  user_placeholder_phone: "Nomor telepon",
  user_placeholder_address: "ADDRESS",
  user_placeholder_city: "KOTA",
  user_placeholder_postalcode: "KODE POS",
  user_placeholder_province: "PROVINSI",
  user_placeholder_oldpassword: "Password lama",
  user_placeholder_newpassword: "Password baru",
  user_placeholder_confirmpassword: "Konfirmasi password baru",

  user_update_success: "Ubah User Berhasil",
  user_update_failed: "Ubah User Gagal",
  user_changepassword_success: "Ubah Password Berhasil",
  user_changepassword_failed: "Ubah Password Gagal",
  user_changepassword_notmatch:
    "Konfirmasi password baru gagal, password tidak sesuai.",

  //partner
  partner_search_name: "Cari Berdasarkan Nama",
  partner_search_email: "Cari Berdasarkan Email",
  partner_search_phone: "Cari Berdasarkan Nomor Telepon",
  partner_search_address: "Cari Berdasarkan Alamat",
  partner_table_title: "Daftar Partner",
  partner_add_title: "Tambah Partner Baru",
  partner_edit_title: "Ubah Data Partner",
  partner_label_name: "Nama",
  partner_label_email: "Email",
  partner_label_phone: "Nomor Telepon",
  partner_label_transport_type: "Tipe Transportasi",
  partner_label_address: "Alamat",
  partner_placeholder_name: "Nama",
  partner_placeholder_email: "EMAIL",
  partner_placeholder_phone: "Nomor telepon",
  partner_placeholder_transport_type: "PILIH TIPE TRANSPORTASI",
  partner_placeholder_address: "Alamat",
  partner_placeholder_filterbyname: "Filter berdasarkan nama",
  partner_tableheader_id: "Partner ID",
  partner_tableheader_name: "Nama",
  partner_tableheader_email: "Email",
  partner_tableheader_transport_type: "Tipe Transportasi",
  partner_tableheader_phone: "Nomor Telepon",
  partner_tableheader_address: "Alamat",
  partner_tableheader_createddate: "Tanggal Pembuatan",
  partner_tableheader_updateddate: "Terakhir Diubah",
  partner_tableheader_action: "Aksi",
  partner_notif_add_title: "Tambah Partner Berhasil",
  partner_notif_add_subtitle: "Partner berhasil ditambahkan",
  partner_notif_edit_title: "Ubah Partner Berhasil",
  partner_notif_edit_subtitle: "Partner berhasil diubah",
  partner_fetch_failed: "Gagal mendapatkan data partner",
  partner_add_success: "Sukses Menambahkan Partner",
  partner_add_failed: "Gagal Menambahkan Partner",
  partner_edit_success: "Sukses Mengubah Partner",
  partner_edit_failed: "Gagal Mengubah Partner",
  partner_delete_success: "Sukses Menonaktifkan Partner",
  partner_delete_failed: "Gagal Menonaktifkan Partner",
  partner_activate_success: "Sukses Mengaktifkan Partner",
  partner_activate_failed: "Gagal Mengaktifkan Partner",

  //customer
  customer: "Pelanggan",
  customer_search_name: "Cari Berdasarkan Nama",
  customer_search_email: "Cari Berdasarkan Email",
  customer_search_phone: "Cari Berdasarkan Nomor Telepon",
  customer_search_address: "Cari Berdasarkan Alamat",
  customer_search_created_date: "Cari Berdasarkan Tanggal Pembuatan",
  customer_search_updated_date: "Cari Berdasarkan Terakhir Diubah",
  customer_table_title: "Daftar Pelanggan",
  customer_add_title: "Tambah Pelanggan Baru",
  customer_edit_title: "Ubah Data Pelanggan",
  customer_add_pic: "PIC",
  customer_add_fax: "Fax",
  customer_add_country: "Negara",
  customer_add_province: "Provinsi",
  customer_add_city: "Kota",
  customer_add_postalcode: "Kode Pos",
  customer_add_taxno: "Nomor Pajak",
  customer_add_taxname: "Nama Pajak",
  customer_add_taxaddress: "Alamat Pajak",
  customer_add_name: "Nama",
  customer_add_email: "Email",
  customer_add_phone: "Nomor Telepon",
  customer_add_prefix: "Prefix",
  customer_add_address: "Alamat",
  customer_add_success_title: "Konfirmasi",
  customer_add_success_text:
    "Data pelanggan berhasil ditambah! Apakah ingin menambahkan data lokasi juga?",
  customer_placeholder_name: "Nama",
  customer_placeholder_email: "Email",
  customer_placeholder_phone: "Nomor Telepon",
  customer_placeholder_prefix: "Pilih Prefix",
  customer_placeholder_fax: "Fax",
  customer_placeholder_address: "Alamat",
  customer_placeholder_country: "Negara",
  customer_placeholder_province: "Provinsi",
  customer_placeholder_city: "Kota",
  customer_placeholder_pic: "PIC",
  customer_placeholder_postalcode: "Kode pos",
  customer_placeholder_taxno: "Nomor Pajak",
  customer_placeholder_taxname: "Nama Pajak",
  customer_placeholder_taxaddress: "Alamat Pajak",
  customer_tableheader_id: "customer ID",
  customer_tableheader_name: "Nama",
  customer_tableheader_email: "Email",
  customer_tableheader_vendor: "Tipe Vendor",
  customer_tableheader_phone: "Nomor Telepon",
  customer_tableheader_pic: "PIC",
  customer_tableheader_address: "Alamat",
  customer_tableheader_companyname: "Nama Perusahaan",
  customer_tableheader_createddate: "Tanggal Pembuatan",
  customer_tableheader_updateddate: "Terakhir Diubah",
  customer_tableheader_action: "Aksi",
  customer_tableheader_picklocation: "Pilih Lokasi",
  customer_warning_nolocation:
    "Customer ini belum memiliki lokasi. Anda dapat menambahkan lokasi pada halaman detail customer.",
  customer_filter_name: "Saring berdasarkan nama",
  customer_filter_from_date: "Awal",
  customer_filter_to_date: "Akhir",
  customer_filter_address: "Saring berdasarkan alamat",
  customer_filter_pic: "Saring berdasarkan nama PIC",
  customer_filter_phone: "Saring berdasarkan telepon",
  customer_add_success: "Sukses Menambah Pelanggan",
  customer_add_failed: "Gagal Menambah Pelanggan",
  customer_update_success: "Sukses Mengubah Pelanggan",
  customer_update_failed: "Gagal Mengubah Pelanggan",
  customer_activate_success: "Sukses Mengaktifkan Pelanggan",
  customer_activate_failed: "Gagal Mengaktifkan Pelanggan",

  searchbyname: "Cari Berdasarkan Nama",
  searchbycurrency: "Cari Berdasarkan Mata Uang",
  searchbyabbreviation: "Cari Berdasarkan Singkatan",
  searchbycapital: "Cari Berdasarkan Ibu Kota",

  test: "Ini adalah test indonesia",
  navbar_title: "JUDUL NAVBAR",
  home_banner_title: `HALO, TERIMA KASIH SUDAH DATANG!`,
  home_banner_desc: `Aplikasi Vue 3 ini menggunakan libraries yaitu Bootstrap 5 dan Vuetify. Kebanyakan komponen yang digunakan dalam App ini berasal dari Vuetify versi 3.xx yang mendukung Vue 3.`,
  home_banner_vue3: `Lihat Vue 3`,
  home_banner_vuetify: `Lihat Vuetify`,
  home_banner_bootstrap5: `Lihat Bootstrap 5`,
  home_banner_explore: `Mulai Eksplor`,

  // location
  location: "Lokasi",
  location_form_add_title: "Tambah Data Lokasi",
  location_form_edit_title: "Ubah Data Lokasi",
  location_data_title: "Data Lokasi",
  location_form_name: "Nama",
  location_form_pic: "PIC",
  location_form_phone: "Nomor Telepon",
  location_form_address: "Alamat",
  location_form_country: "Negara",
  location_form_province: "Provinsi",
  location_form_city: "Kota",
  location_form_district: "Kecamatan",
  location_form_postal_code: "Kode Pos",
  location_form_notes:
    "Perhatian: Saat ini sedang menyunting data lokasi detail dari",
  location_form_cancel: "Batalkan",
  location_form_reset: "Atur Ulang",
  location_form_submit: "Simpan Lokasi",
  location_placeholder_address: "Masukkan lokasi",
  location_placeholder_country: "Masukkan negara",
  location_placeholder_province: "Masukkan provinsi",
  location_placeholder_city: "Masukkan kota",
  location_placeholder_district: "Masukkan kecamatan",
  location_placeholder_postal_code: "Masukkan kode pos",
  location_search_name: "Cari Berdasarkan Nama",
  location_search_pic: "Cari Berdasarkan PIC",
  location_search_phone: "Cari Berdasarkan Nomor Telepon",
  location_search_address: "Cari Berdasarkan Alamat",
  location_search_created_date: "Cari Berdasarkan Tanggal Dibuat",
  location_search_updated_date: "Cari Berdasarkan Tanggal Diperbaharui",
  location_table_header: "Daftar Lokasi",
  location_table_header_name: "Nama",
  location_table_header_pic: "PIC",
  location_table_header_phone: "Nomor Telepon",
  location_table_header_address: "Alamat",
  location_table_header_created: "Tanggal Pembuatan",
  location_table_header_updated: "Terakhir Diubah",
  location_table_header_action: "Aksi",
  location_add_success: "Sukses Menambah Lokasi",
  location_add_failed: "Gagal Menambah Lokasi",
  location_update_success: "Sukses Mengubah Lokasi",
  location_update_failed: "Gagal Mengubah Lokasi",

  fetching_countries_error: "Gagal Memperoleh Data Negara",
  fetching_provinces_error: "Gagal Memperoleh Data Provinsi",
  fetching_cities_error: "Gagal Memperoleh Data Kota",
  fetching_districts_error: "Gagal Memperoleh Data Kecamatan",

  // Error
  must_number_error: "harus berupa angka!",
  is_required: "harus diisi!",
  not_valid: "tidak valid!",
  invalid_location: "Harap pilih lokasi yang tersedia!",

  // order
  order_table_title: "Daftar Order",
  order_tableheader_orderid: "Order ID",
  order_tableheader_ordernumber: "Nomor Order",
  order_label_orderstatus: "Status Order",
  order_tableheader_city: "Kota",
  order_tableheader_createddate: "Tanggal Pembuatan",
  order_tableheader_updatedat: "Terakhir Diubah",
  order_tableheader_customername: "Nama Customer",
  order_tableheader_customerid: "Customer ID",
  order_tableheader_origincity: "Kota Asal",
  order_tableheader_destinationcity: "Kota Tujuan",
  order_tableheader_originaddress: "Alamat Asal",
  order_tableheader_destinationaddress: "Alamat Tujuan",
  order_tableheader_orderstatus: "Status Order",
  order_tableheader_status: "Status",
  invoice_tableheader_status: "Status Invoice",
  order_label_customer: "Customer",
  order_label_customerpic: "PIC",
  order_label_customeremail: "Email",
  order_label_customerphone: "Nomor Telepon",
  order_label_origin: "Lokasi Asal",
  order_label_origincity: "Kota Asal",
  order_label_originaddress: "Alamat Asal",
  order_label_destination: "Lokasi Tujuan",
  order_label_destinationcity: "Kota Tujuan",
  order_label_destinationaddress: "Alamat Tujuan",
  order_label_ordernumber: "Nomor Order",
  order_label_remark: "Keterangan",
  order_add_title: "Tambah Order Baru",
  order_edit_title: "Ubah Data Order",
  order_placeholder_customer: "Cari customer",
  order_placeholder_customerpic: "PIC customer",
  order_placeholder_customeremail: "EMAIL CUSTOMER",
  order_placeholder_customerphone: "Nomor telepon customer",
  order_placeholder_origin: "Lokasi asal",
  order_placeholder_origincity: "Kota asal",
  order_placeholder_originaddress: "Alamat asal",
  order_placeholder_destination: "Lokasi tujuan",
  order_placeholder_destinationcity: "Kota tujuan",
  order_placeholder_destinationaddress: "Alamat tujuan",
  order_placeholder_ordernumber: "Nomor order",
  order_placeholder_filterbyordernumber: "Filter berdasarkan nomor order",
  order_add: "Menambah Order",
  order_add_redirect:
    "Sukses Menambah Order! Apakah ingin menambahkan order detail (kamu akan diarahkan ke halaman detail order)?",
  order_add_success: "Sukses Menambah Order",
  order_add_failed: "Gagal Menambah Order",
  order_edit_success: "Sukses Mengubah Order",
  order_edit_failed: "Gagal Mengubah Order",
  sla: "SLA",
  start_order: "Tanggal Mulai",
  finish_order: "Tanggal Selesai",
  contact: "Kontak",
  emergency: "Darurat",
  contact_type: "Tipe Kontak",
  contact_name: "Nama Kontak",
  add_contact: "Tambah Kontak",
  add_contact_failed: "Gagal menambahkan kontak driver",
  edit_contact: "Ubah Kontak",
  edit_contact_failed: "Gagal memperbarui kontak driver",

  purchase_order_add_success: "Sukses Menambah Purchase Order",
  purchase_order_add_failed: "Gagal Menambah Purchase Order",

  order_location_list: "Daftar Lokasi",
  order_origin_location: "Pilih Lokasi Awal",
  order_destination_location: "Pick Lokasi Tujuan",
  order_customer_modal: "Pilih Customer",
  order_customer_list: "Daftar Customer",
  order_sla: "Order SLA (Jam)",

  //order detail
  orderdocument_table_title: "Daftar Dokumen Order",
  orderdetail_table_title: "Daftar Detail Order",
  orderdetail_tableheader_orderdetailid: "ID",
  orderdetail_tableheader_oriaddress: "Alamat Asal",
  orderdetail_tableheader_destaddress: "Alamat Tujuan",
  orderdetail_tableheader_transporttype: "Transport Type",
  orderdetail_tableheader_loadtype: "Load Type",
  orderdetail_tableheader_movetype: "Move Type",
  orderdetail_tableheader_containertype: "Jenis Container",
  orderdetail_tableheader_vehicletype: "Container Type",
  orderdetail_tableheader_partner: "Partner",
  orderdetail_tableheader_startdate: "Tanggal Mulai",
  orderdetail_tableheader_enddate: "Tanggal Selesai",
  orderdetail_tableheader_createddate: "Tanggal Pembuatan",
  orderdetail_tableheader_updatedate: "Terakhir Diubah",
  orderdetail_tableheader_orderdetailno: "No Order Detail",
  loading_list_status: "Status Loading List",
  orderdetail_label_orderdetailid: "ID Order Detail",
  orderdetail_label_oriaddress: "Alamat Asal",
  orderdetail_label_destaddress: "Alamat Tujuan",
  orderdetail_label_transporttype: "Transport Type",
  orderdetail_label_loadtype: "Load Type",
  orderdetail_label_movetype: "Move Type",
  orderdetail_label_containertype: "Container Type",
  orderdetail_label_vehicletype: "Vehicle Type",
  orderdetail_label_partner: "Partner",
  orderdetail_label_startdate: "Tanggal Mulai Pesanan",
  orderdetail_label_enddate: "Tanggal Selesai Pesanan",
  orderdetail_label_createddate: "Tanggal Pembuatan",
  orderdetail_label_updatedat: "Terakhir Diubah",
  orderdetail_label_qty: "Jumlah",
  orderdetail_add_title: "Tambah Detail Order",
  orderdetail_edit_title: "Ubah Detail Order",
  orderdetail_label_orderdetailno: "Nomor Detail Order",
  orderdetail_placeholder_orderdetailno: "NOMOR DETAIL ORDER",
  orderdetail_placeholder_originaddress: "Alamat asal",
  orderdetail_placeholder_destinationaddress: "Alamat tujuan",
  orderdetail_placeholder_transporttype: "Transport type",
  orderdetail_placeholder_loadtype: "Load type",
  orderdetail_placeholder_movetype: "Move type",
  orderdetail_placeholder_vehicletype: "Vehicle type",
  orderdetail_placeholder_containertype: "Container Type",
  orderdetail_placeholder_qty: "Jumlah",
  orderdetail_placeholder_partner: "PARTNER",
  orderdetail_placeholder_startjobdate: "TANGGAL MULAI",
  orderdetail_placeholder_endjobdate: "TANGGAL SELESAI",
  orderdetail_add_success: "Sukses Menambah Order",
  orderdetail_add_failed: "Gagal Menambah Order",
  orderdetail_edit_success: "Sukses Mengubah Order",
  orderdetail_edit_failed: "Gagal Mengubah Order",
  orderdetail_delete_success: "Sukses Menghapus Order",
  orderdetail_delete_failed: "Gagal Menghapus Order",
  orderdetail_warning_jobdate:
    "Tanggal mulai harus lebih awal dari tanggal selesai",

  // Order container
  ordercontainer_table_title: "Daftar Detail Container",
  ordercontainer_nocontainer: "No Container",
  ordercontainer_containertype: "Tipe Container",
  ordercontainer_sealnumber: "Nomor Segel",
  ordercontainer_store_success: "Berhasil menambahkan data container",
  ordercontainer_store_fail: "Gagal menambahkan data container",
  ordercontainer_update_success: "Berhasil mengubah data container",
  ordercontainer_update_fail: "Gagal mengubah data container",

  // Track status
  trackstatus_table_title: "List Track Status",
  trackstatus_status_name: "Status",
  trackstatus_status_date_time: "Tanggal & Waktu",
  trackstatus_remark: "Keterangan",
  trackstatus_created_at: "Dibuat Pada",
  trackstatus_order_no: "No Pesanan",
  trackstatus_order_detail_no: "Nomor Detail",
  trackstatus_status: "Status",
  Trackstatus_store_success: "Berhasil menambahkan status lacak",
  Trackstatus_store_fail: "Gagal menambahkan status lacak",
  Trackstatus_update_success: "Berhasil mengubah status lacak",
  Trackstatus_update_fail: "Gagal mengubah status lacak",

  orderpurchase_table_title: "Daftar Purchase Order",
  orderpurchase_nopo: "Nomor Purchase Order",
  orderpurchase_partnername: "Nama Partner",
  orderpurchase_totalpo: "Total",
  orderpurchase_container_type: "Tipe Container",
  orderpurchase_qty: "Kuantitas",
  orderpurchase_freight_element: "Freight Element",
  orderpurchase_vehicle_type: "Tipe Kendaraan",
  orderpurchase_amount: "Jumlah",
  orderpurchase_tax: "Pajak",
  orderpurchase_subtotal: "Subtotal",
  orderpurchase_total: "Total",
  orderpurchase_remark: "Remark",
  orderpurchase_get_failed: "Gagal mendapatkan purchase order data",
  orderpurchase_update_success: "Berhasil mengubah data purchase order",
  orderpurchase_update_fail: "Gagal mengubah data purchase order",
  orderpurchase_detail_get_failed: "Gagal mendapatkan detail purchase order",
  orderpurchase_orderdetail: "Nomor Order Detail",

  orderpurchase_detail_store_success:
    "Berhasil menambahkan data detail purchase order",
  orderpurchase_detail_store_failed:
    "Gagal menambahkan data detail purchase order",
  orderpurchase_detail_update_success:
    "Berhasil memperbarui data detail purchase order",
  orderpurchase_detail_update_failed:
    "Gagal memperbarui data detail purchase order",
  orderpurchase_detail_destroy_success:
    "Berhasil menghapus data detail purchase order",
  orderpurchase_detail_destroy_failed:
    "Gagal menghapus data detail purchase order",

  // Order - Trucking
  ordertrucking_add_title: "Tambahkan Trucking Baru",
  ordertrucking_table_title: "Daftar Order Trucking",
  ordertrucking_truckingorderno: "Nomor Order Trucking",
  ordertrucking_containerno: "Nomor Container",
  ordertrucking_vehicletype: "Tipe Kendaraan",
  ordertrucking_orderdate: "Tanggal Order",
  ordertrucking_companyorderdetailid: "Company Order Detail",
  ordertrucking_orderdetailno: "Nomor Order Detail",
  ordertrucking_partnerfleetid: "Partner Fleet",
  ordertrucking_location: "Lokasi",

  order_trucking: "Order Trucking",
  ordertrucking_store_success: "Berhasil menambahkan data order trucking",
  ordertrucking_store_failed: "Gagal menambahkan data order trucking",
  ordertrucking_add_success_text:
    "Data order trucking berhasil ditambah! Apakah ingin melihat detail juga?",

  ordertrucking_update_title: "Update Trucking Data",
  ordertrucking_update_success: "Berhasil memperbarui data order trucking",
  ordertrucking_update_failed: "Gagal memperbarui data order trucking",

  order_trucking_milestone: "Order Trucking Milestone",
  order_trucking_milestone_add: "Tambah Trucking Milestone Baru",
  order_trucking_milestone_edit: "Ubah Trucking Milestone",
  ordertrucking_milestone_store_success:
    "Berhasil menambahkan data order trucking milestone",
  ordertrucking_milestone_store_failed:
    "Gagal menambahkan data order trucking milestone",
  ordertrucking_milestone_update_success:
    "Berhasil memperbarui data order trucking milestone",
  ordertrucking_milestone_update_failed:
    "Gagal memperbarui data order trucking milestone",

  // Invoice
  invoice_table_title: "Daftar Invoice",
  invoice_invoice_type: "Tipe Faktur",
  invoice_grand_total: "Grand Total",
  invoice_due_date: "Tenggat Waktu",
  invoice_credit_days: "Waktu Cicilan",
  invoice_customer: "Customer",
  invoice_payer_name: "Pembayar",
  invoice_payment_type: "Tipe Pembayaran",
  invoice_remark: "Remark",
  invoice_vehicle_type: "Tipe Kendaraan",

  invoice_get_failed: "Gagal mendapatkan invoice data",
  invoice_detail_get_failed: "Gagal mendapatkan detail invoice customer",
  invoice_add_data: "Tambah Invoice Customer",
  invoice_add_data_success: "Berhasil menambahkan invoice customer",
  invoice_add_data_failed: "Gagal menambahkan invoice customer",
  invoice_add_data_redirect:
    "Sukses Menambah Invoice Customer! Apakah anda ingin menambahkan detail (pergi ke halaman detail invoice)?",
  invoice_edit_data: "Ubah Invoice Customer",
  invoice_edit_data_success: "Berhasil memperbarui invoice customer",
  invoice_edit_data_failed: "Gagal memperbarui invoice customer",

  invoice_detail_store_success: "Berhasil menambahkan data detail invoice",
  invoice_detail_store_failed: "Gagal menambahkan data detail invoice",
  invoice_detail_update_success: "Berhasil memperbarui data detail invoice",
  invoice_detail_update_failed: "Gagal memperbarui data detail invoice",
  invoice_detail_destroy_success: "Berhasil menghapus data detail invoice",
  invoice_detail_destroy_failed: "Gagal menghapus data detail invoice",

  invoice_type_fetch_failed: "Gagal mengambil tipe invoice",
  payment_type_fetch_failed: "Gagal mengambil tipe pembayaran",
  customer_fetch_failed: "Gagal mengambil customer",

  invoicevendor_invoice_no: "Nomor Faktur",
  invoicevendor_order_no: "Nomor Order",
  invoicevendor_invoice_date: "Tanggal Faktur",
  invoicevendor_orderno: "Nomor Order",
  invoicevendor_partner: "Partner",
  invoicevendor_tax: "Pajak %",
  invoicevendor_status: "Status",
  invoicevendor_total_amount: "Jumlah Total",
  invoicevendor_placeholder_filterbyinvoiceno:
    "Filter berdasarkan nomor faktur",
  invoicevendor_placeholder_filterbyorderno: "Filter berdasarkan nomor order",
  invoicevendor_placeholder_partner: "Cari Partner",
  invoicevendor_add_data: "Tambahkan Faktur Vendor Baru",
  invoicevendor_add_data_success: "Berhasil menambahkan invoice vendor",
  invoicevendor_add_data_failed: "Gagal menambahkan invoice vendor",
  invoicevendor_add_data_redirect:
    "Sukses Menambah Invoice Vendor! Apakah anda ingin menambahkan detail (pergi ke halaman detail invoice vendor)?",
  invoicevendor_edit_data: "Edit Faktur Vendor",
  invoicevendor_edit_data_success: "Berhasil memperbarui invoice vendor",
  invoicevendor_edit_data_failed: "Gagal memperbarui invoice vendor",
  invoicevendor_table_title: "Daftar Invoice Vendor",
  invoicevendor_get_failed: "Gagal mendapatkan invoice vendor data",

  invoicevendor_detail_get_failed: "Gagal mendapatkan detail invoice vendor",
  invoicevendor_detail_freight_element: "Freight Element",
  invoicevendor_detail_amount: "Jumlah",
  invoicevendor_detail_qty: "Kuantitas",
  invoicevendor_detail_tax: "Pajak %",
  invoicevendor_detail_subtotal: "Subtotal",
  invoicevendor_detail_total: "Total",
  invoicevendor_detail_remark: "Remark",

  invoicevendor_detail_store_success:
    "Berhasil menambahkan data detail invoice vendor",
  invoicevendor_detail_store_failed:
    "Gagal menambahkan data detail invoice vendor",
  invoicevendor_detail_update_success:
    "Berhasil memperbarui data detail invoice vendor",
  invoicevendor_detail_update_failed:
    "Gagal memperbarui data detail invoice vendor",
  invoicevendor_detail_destroy_success:
    "Berhasil menghapus data detail invoice vendor",
  invoicevendor_detail_destroy_failed:
    "Gagal menghapus data detail invoice vendor",

  // report/truckposition
  fleet_placeholder: "ARMADA",
  partner_name: "Nama Partner",
  map_view: "Tampilan Peta",
  view_data: "Tampilan Data",
  partnerfleet: "Armada",
  refresh: "Perbarui Data",
  close: "Closed",
  open: "Open",
  device_id: "ID Perangkat",
  device_code: "Kode Perangkat",
  door_number: "Nomor Pintu",
  door_left: "Pintu Kiri",
  door_rear: "Pintu Belakang",
  door_right: "Pintu Kanan",
  fuel_level: "Level Bahan Bakar",
  last_update: "Update Terakhir",
  latitude: "Latitude",
  longitude: "Longitude",
  latlong: "Lat / Long",
  odometer: "Odometer",
  reg_number: "Nomor Polisi",
  reg_number_with_door: "Nomor Polisi Dengan Pintu",
  speed: "Kecepatan (km/jam)",
  temp_c: "Temperatur (Celcius)",
  trucking_position_id: "ID Truck Position",
  vsys: "VSYS",
  machine: "Machine",
  update_date: "Tanggal Diubah",
  search: "Pencarian melalui ",
  fetch_failed: "Gagal mendapatkan data",
  address: "Alamat",

  //Sample Page
  sample_page_title: "Halaman Sampel",
  sample_page_subtitle:
    "Halaman ini berisikan sampel (GET, POST, dll.) untuk keperluan belajar. ",

  get_sample_data: "GET Sample Data",
  get_sample_data_desc:
    "Pada bagian ini, kita akan menggunakan Vuex Action dikombinasikan dengan native JS API call request GET untuk mendapatkan beberapa data.",

  post_sample_data: "POST Sample Data",
  post_sample_data_desc:
    "Pada bagian ini, kita akan menggunakan Vuex Action dikombinasikan dengan native JS API call request POST untuk menyimpan data.",

  put_sample_data: "PUT Sample Data",
  put_sample_data_desc:
    "Pada bagian ini, kita akan menggunakan Vuex Action dikombinasikan dengan native JS API call request PUT untuk mengubah data.",

  delete_sample_data: "DELETE Sample Data",
  delete_sample_data_desc:
    "Pada bagian ini, kita akan menggunakan Vuex Action dikombinasikan dengan native JS API call request DELETE untuk menghapus data.",

  //Home Page
  get_sample_port: "GET Data Port",

  // Button
  btn_print: "Cetak",
  btn_download: "Unduh",

  // Button Tooltip
  btn_tooltip_back: "Kembali ke halaman sebelumnya",
  btn_tooltip_update: "Perbarui",
  btn_tooltip_search: "Cari",
  btn_tooltip_add: "Tambahkan",
  btn_tooltip_upload: "Unggah",
  btn_tooltip_delete: "Hapus",
  btn_tooltip_inactive: "Nonaktifkan",
  btn_tooltip_edit: "Ubah",
  btn_tooltip_view: "Lihat",
  btn_tooltip_reset: "Pulihkan",
  btn_tooltip_active: "Aktifkan",
  btn_tooltip_location: "Pilih lokasi",
  btn_tooltip_submit: "Simpan",
  btn_tooltip_cancel: "Batalkan",
  btn_tooltip_truck: "posisi truck",
  btn_tooltip_refresh_truck: "Menarik data truck position terbaru",

  btn_tooltip_print_order: "Cetak Order Summary",
  btn_tooltip_print_po: "Cetak PO",
  btn_tooltip_add_po: "Tambah PO",
  btn_tooltip_edit_po: "Ubah PO",
  btn_tooltip_download_document: "Unduh Dokumen",
  btn_tooltip_delete_document: "Hapus Dokumen",
  btn_tooltip_save: "Simpan",

  btn_customer_invoice: "Faktur Pelanggan",

  // Back confirmation
  confirm_back: "Semua data yang belum disimpan akan terhapus. Apa kamu yakin?",

  //general_use
  add_order_detail: "Tambah Detail Pesanan",
  add_container: "Tambah Kontainer",
  add_track_status: "Tambah Status Lacak",
  edit_order_detail: "Ubah Detail Pesanan",
  edit_container: "Ubah Kontainer",
  add_document: "Tambah Document",
  document_name: "Nama Dokumen",
  document_type: "Tipe Dokumen",
  container_type: "Tipe Kontainer",
  remark: "Remark",
  status: "Status",
  document: "Dokumen",
  partner: "Partner",
  uploaded_by: "Diupload Oleh",
  uploaded_on: "Diupload Pada",

  // Fleet
  fleet_table_title: "Daftar Fleet Partner",

  fleet_activate_success: "Sukses Mengaktifkan Fleet Partner",
  fleet_activate_failed: "Gagal Mengaktifkan Fleet Partner",
  fleet_inactivate_success: "Sukses Menonaktifkan Fleet Partner",
  fleet_inactivate_failed: "Gagal Menonaktifkan Fleet Partner",
  fleet_fetch_failed: "Gagal mendapatkan data fleet partner",

  fleet_tableheader_name: "Nama",
  fleet_tableheader_partner: "Partner",
  fleet_tableheader_vehicle_type: "Tipe Kendaraan",
  fleet_tableheader_transport_type: "Tipe Transportasi",
  fleet_tableheader_plate_number: "Nomor Polisi",
  fleet_tableheader_hull_number: "Nomor Lambung Kapal",
  fleet_tableheader_created_date: "Tanggal Pembuatan",
  fleet_tableheader_updated_date: "Terakhir Diubah",
  fleet_tableheader_action: "Aksi",

  fleet_search_name: "Cari berdasarkan nama",
  fleet_search_partner: "Cari berdasarkan partner",
  fleet_search_vehicle_type: "Cari berdasarkan tipe kendaraan ",
  fleet_search_transport_type: "Cari berdasarkan tipe transportasi",
  fleet_search_updated_date: "Cari berdasarkan terakhir diubah",
  fleet_search_created_date: "Cari berdasarkan tanggal pembuatan",
  fleet_search_hull_number: "Cari berdasarkan nomor lambung kapal",
  fleet_search_plate_number: "Cari berdasarkan nomor polisi",

  fleet_add_name: "Nama",
  fleet_add_plate_number: "Nomor Polisi",
  fleet_add_hull_number: "Nomor Lambung Kapal",
  fleet_add_partner: "Partner",
  fleet_add_vehicle_type: "Tipe Kendaraan",
  fleet_add_transport_type: "Tipe Transportasi",
  fleet_add_primary_driver: "Pengemudi Utama",
  fleet_add_secondary_driver: "Pengemudi Kedua",
  fleet_add_brand: "Merek",

  fleet: "Fleet Partner",
  fleet_add_success: "Sukses Menambah Fleet Partner",
  fleet_add_failed: "Gagal Menambah Fleet Partner",

  fleet_add_title: "Tambah Fleet Partner",
  fleet_edit_title: "Ubah Fleet Partner",
  fleet_view_title: "Lihat Fleet Partner",

  fleet_placeholder_name: "NAMA",
  fleet_placeholder_plate_number: "NOMOR POLISI",
  fleet_placeholder_hull_number: "NOMOR LAMBUNG KAPAL",
  fleet_placeholder_partner: "PILIH PARTNER",
  fleet_placeholder_vehicle_type: "PILIH TIPE KENDARAAN",
  fleet_placeholder_transport_type: "PILIH TIPE TRANSPORTASI",

  fleet_edit_success: "Sukses Memperbaharui Fleet Partner",
  fleet_edit_failed: "Gagal mMemperbaharui Fleet Partner",

  // Freight
  freight_table_title: "Daftar Freight Element",
  freight_activate_success: "Sukses Mengaktifkan Freight Element",
  freight_activate_failed: "Gagal Mengaktifkan Freight Element",
  freight_inactivate_success: "Sukses Menonaktifkan Freight Element",
  freight_inactivate_failed: "Gagal Menonaktifkan Freight Element",
  freight_fetch_failed: "Gagal mendapatkan data freight element",

  freight_tableheader_code: "Kode Freight Element",
  account_tableheader_code: "Kode Akun",
  freight_tableheader_description: "Deskripsi",
  freight_tableheader_created_at: "Tanggal Pembuatan",
  freight_tableheader_updated_at: "Terakhir Diubah",
  freight_tableheader_action: "Aksi",

  freight_search_code: "Cari berdasarkan kode",
  account_search_code: "Cari berdasarkan akun",
  freight_search_description: "Cari berdasarkan deskripsi",
  freight_search_updated_at: "Cari berdasarkan terakhir diubah",
  freight_search_created_at: "Cari berdasarkan tanggal pembuatan",

  freight_add_code: "Kode Freight Element",
  account_add_code: "Kode Akun",
  freight_add_description: "Nama",

  freight: "Freight Element",
  code: "Kode",
  freight_add_success: "Sukses Menambah Freight Element",
  freight_add_failed: "Gagal Menambah Freight Element",

  freight_add_title: "Tambah Freight Element",
  freight_edit_title: "Ubah Freight Element",
  freight_view_title: "Lihat Freight Element",

  freight_placeholder_code: "KODE FREIGHT ELEMENT",
  account_placeholder_code: "KODE AKUN",
  freight_placeholder_desc: "NAMA",

  freight_edit_success: "Sukses Memperbaharui Freight Element",
  freight_edit_failed: "Gagal Memperbaharui Freight Element",

  freight_placeholder_filterbycode: "Filter berdasarkan kode",
  freight_placeholder_filterbyname: "Filter berdasarkan nama",
  word_code: "Kode",
  freight_code_not_unique_error: "Kode freight element sudah pernah digunakan!",

  // Command Center
  tableheader_job_order_number: "Nomor Job Order",
  tableheader_plat_number: "Nomor Polisi",
  tableheader_speed: "Kecepatan (km/jam)",
  tableheader_status: "Status",
  tableheader_latlong: "Latitude, Longitude",
  tableheader_last_update: "Last Update",
  status_fetch_job_position_failed: "Gagal mengambil data command center",
  status_fetch_latest_job_position_failed:
    "Gagal mengambil data pusat komando terbaru",
  status_fetch_job_position_total_status_failed:
    "Gagal mengambil data total status dasbor",
  inland_departure_trucking_assigned:
    "Data ini menunjukkan jumlah pemesanan yang telah dikonfirmasi",
  inland_departure_depart_from_depo:
    "Data ini menunjukkan jumlah truck yang telah berangkat dari depo",
  inland_departure_arrived_at_warehouse:
    "Data ini menunjukan jumlah truck yang telah tiba di gudang",
  inland_arrival_trucking_assigned:
    "Data ini menunjukkan jumlah pemesanan yang telah dikonfirmasi",
  inland_arrival_depart_from_depo:
    "Data ini menunjukkan jumlah truck yang telah berangkat dari depo",
  inland_arrival_arrived_at_warehouse:
    "Data ini menunjukan jumlah truck yang telah tiba di gudang",

  //po
  purchase_order_number: "Nomor Purchase Order",
  purchase_order_add: "Tambah Purchase Order",
  po_date: "Tanggal Purchase Order",
  purchase_order_add_redirect:
    "Sukses Menambah Purchase Order! Apakah anda ingin menambahkan detail (pergi ke halaman detail purchase order)?",
  purchase_order_add_title: "Tambah Purchase Order Baru",
  purchase_order_edit_title: "Ubah Data Purchase Order",
  status_fetch_failed: "Gagal mengambil status",
  edit_data: "Ubah",

  no_header: "No",
  no_label: "No",

  // General Setting User
  general_setting_filter_name_label: "Nama",
  general_setting_filter_name_placeholder: "Filter berdasarkan nama",
  general_setting_header_user_id: "User ID",
  general_setting_header_role: "Role",
  general_setting_header_fullname: "Nama Lengkap",
  general_setting_header_email: "Email",
  general_setting_header_phone: "Nomor Telepon",
  general_setting_header_transaction_type: "Tipe Transaksi",
  general_setting_header_pattern: "Pola",
  general_setting_header_preview: "Pratinjau",
  general_setting_header_created_at: "Tanggal Pembuatan",
  general_setting_add_user: "Tambah User Baru",
  general_setting_edit_user: "Edit User",
  general_setting_form_firstname: "Nama Depan",
  general_setting_form_lastname: "Nama Belakang",
  general_setting_form_email: "Email",
  general_setting_form_phone: "Nomor Telepon",
  general_setting_add_numbering: "Tambah Nomor Baru",
  general_setting_edit_numbering: "Edit Nomor",

  general_setting_add_success: "Berhasil menambahkan user",
  general_setting_add_failed: "Gagal menambahkan user",
  general_setting_edit_success: "Berhasil meperbarui user",
  general_setting_edit_failed: "Gagal meperbarui user",
  general_setting_activate_success: "Berhasil mengaktifkan user",
  general_setting_activate_failed: "Gagal mengaktifkan user",
  general_setting_inactivate_success: "Berhasil menonaktifkan user",
  general_setting_inactivate_failed: "Gagal menonaktifkan user",
  general_setting_add_numbering_success: "Berhasil menambahkan nomor",
  general_setting_add_numbering_failed: "Gagal menambahkan nomor",
  general_setting_edit_numbering_success: "Berhasil meperbarui nomor",
  general_setting_edit_numbering_failed: "Gagal meperbarui nomor",
  general_setting_inactivate_numbering_success: "Berhasil menonaktifkan nomor",
  general_setting_inactivate_numbering_failed: "Gagal menonaktifkan nomor",
  general_setting_user_notif_fetch_failed:
    "Gagal mendapatkan data notification recepient",
  general_setting_user_notif_update_success:
    "Sukses Memperbaharui Notification Recepient",
  general_setting_user_notif_update_failed:
    "Gagal Memperbaharui Notification Recepient",

  // General Setting Role
  role_tableheader_name: "Nama",
  role_tableheader_created_at: "Tanggal Pembuatan",
  role_tableheader_updated_at: "Terakhir Diubah",
  role_tableheader_status: "Status",
  role_tableheader_action: "Aksi",

  role_search_name: "Cari berdasarkan nama",
  role_search_created_at: "Cari berdasarkan tanggal pembuatan",
  role_search_updated_at: "Cari berdasarkan tanggal diubah",
  role_search_status: "Cari berdasarkan status",

  role_fetch_failed: "Gagal mendapatkan data role",
  role_placeholder_rolename: "Nama Role",
  role_label_rolename: "Nama Role",

  role_add_success: "Sukses Menambahkan Role",
  role_add_failed: "Gagal Menambahkan Role",
  role_edit_success: "Sukses Memperbaharui Role",
  role_edit_failed: "Gagal Memperbaharui Role",

  role_activate_success: "Sukses Mengaktifkan Role",
  role_activate_failed: "Gagal Mengaktifkan Role",
  role_inactivate_success: "Sukses Menonaktifkan Role",
  role_inactivate_failed: "Gagal Menonaktifkan Role",

  btn_tooltip_assign: "Menetapkan",
  role_menu_fetch_failed: "Gagal mendapatkan data role menu",
  role_menu_edit_success: "Sukses Memperbaharui Role Menu",
  role_menu_edit_failed: "Gagal Memperbaharui Role Menu",

  partner_pic: "PIC Partner",
  pic_name: "Nama PIC",
  pic_email: "Email PIC",
  pic_phone: "Telepon PIC",
  requester_company: "Perusahaan Peminta",
  email: "Email",
  phone: "Nomor Telepon",
  func_name: "Fungsi",
  position: "Posisi",
  add_pic: "Tambah PIC",
  functionality: "Fungsi",
  name: "Nama Lengkap",
  save: "Data telah disimpan",
  fail: "Data gagal disimpan",
  update: "Data telah diubah",
  customer_pic: "PIC Customer",
  created_date: "Tanggal Buat",
  updated_date: "Tanggal Ubah",
  edit_pic: "Ubah PIC",
  account_code: "Kode Akun",
  account_name: "Nama Akun",
  createddate: "Tanggal Buat",
  updateddate: "Tanggal Ubah",
  coa: "COA",
  get_failed: "Gagal mengambil data",
  level: "Level",
  parent: "Parent",
  type: "Tipe",
  add_success: "Berhasil menambah data",
  add_failed: "Gagal menambah data",
  edit_success: "Berhasil mengubah data",
  edit_failed: "Gagal mengubah data",
  filter_by: "Filter berdasarkan",
  typing: "Ketik",
  no_photo_found: "Tidak ada foto ditemukan",
  numbering: "Penomoran",
  zero_lead: "Digit Number",
  separator: "Separator",

  main_email: "Email Utama",
  operational_email: "Email Operational",
  finance_email: "Email Finance",
  stnk: "STNK",
  truck_year: "Tahun Truck",
  stnk_exp_date: "Tanggal Kadaluwarsa STNK",

  // COA
  account_used_parent: "Akun ini sudah digunakan sebagai parent",
  account_used_freight: "Akun ini sudah digunakan pada freight element",
  success_upload_doc: "Berhasil menambahkan dokumen",
  failed_upload_doc: "Gagal menambahkan dokumen",
  upload_coa: "Coa",

  // Driver
  add_driver: "Tambah Driver",

  driver_tableheader_username: "Username",

  driver: "Pengemudi",
  driver_table_title: "Daftar Driver",
  driver_tableheader_name: "Nama",
  driver_tableheader_partnername: "Nama Partner",
  driver_tableheader_driverlicenseno: "No SIM",
  driver_tableheader_driverlicensetype: "Tipe SIM",
  driver_tableheader_createddate: "Tanggal Pembuatan",
  driver_tableheader_updateddate: "Tanggal Diperbarui",
  driver_tableheader_status: "Status",

  driver_add_title: "Tambah Driver Baru",
  driver_add_name: "Nama",
  driver_add_phone: "Telepon",
  driver_add_email: "Email",
  driver_add_banktype: "Bank",
  driver_add_bankaccount: "Nomor Rekening",
  driver_add_birthplace: "Tempat Lahir",
  driver_add_dob: "Tanggal Lahir",
  driver_add_address: "Alamat",
  driver_add_identityno: "Nomor Identitas",
  driver_add_driverlicenseno: "Nomor SIM",
  driver_add_driverlicensetype: "Tipe SIM",
  driver_add_idcardpath: "KTP",
  driver_add_driverlicensepath: "SIM",
  driver_add_driverlicenseexpdate: "Masa Aktif SIM",
  driver_add_partner: "Partner",
  driver_add_success: "Berhasil menambahkan pengemudi",
  driver_add_failed: "Gagal menambahkan pengemudi",
  driver_add_success_text:
    "Data driver berhasil ditambah! Apakah ingin melihat detail juga?",

  driver_edit_title: "Ubah Data Pengemudi",
  driver_edit_success: "Berhasil memperbarui pengemudi",
  driver_edit_failed: "Gagal memperbarui pengemudi",
  driver_upload_file_failed: "Gagal mengunggah file",

  driver_activate_success: "Sukses Mengaktifkan Pengemudi",
  driver_activate_failed: "Gagal Mengaktifkan Pengemudi",

  setup_driver_failed: "Gagal mengubah pengemudi",
  same_driver: "Pengemudi tidak boleh sama",

  // Marketplace
  type_date: "Tipe Tanggal",
  job_code: "Kode Job",
  description: "Deskripsi",
  posted_job_date: "Tanggal Job Diposting",
  picked_job_date: "Tanggal Job Dipilih",
  posted_by: "Diposting Oleh",
  get_access_token_failed: "Gagal mendapatkan access token",
  get_job_partner_failed: "Gagal mendapatkan job partner data",
  get_community_request_failed: "Gagal mendapatkan community request data",
  list: "Daftar",
  order_request_no: "Nomor Order Request",
  pickup_date: "Tanggal Penjemputan",
  origin_remark: "Catatan Asal",
  destination_remark: "Catatan Tujuan",

  // Marketplace - Market API
  open_requests: "Open Requests",
  my_orders: "My Orders",
  pick_job: "Pick Job",
  cancel_order: "Cancel Order",
  create_order_request: "Buat Order Request",
  request_no: "Nomor Request",
  request_desc: "Deskripsi Request",
  status_open: "Open",
  status_picked: "Picked",
  status_expired: "Closed - Expired",
  status_completed: "Completed",
  confirm_pick_job: "Konfirmasi Pick Job",
  confirm_pick_job_msg: "Apakah Anda yakin ingin mengambil job ini?",
  confirm_cancel_order: "Konfirmasi Cancel Order",
  cancel_reason: "Alasan Pembatalan",
  cancel_reason_required: "Alasan pembatalan wajib diisi.",
  btn_cancel: "Batal",
  add_order_request: "Tambah Order Request",
  service_category_name: "Nama Kategori Service",
  expired_date_tooltip: "Tenggang waktu posting product",
  confirm_change_category_msg: "Mengganti kategori akan menghapus semua data yang telah diisi. Lanjutkan?",
  pick_job_success: "Job berhasil diambil.",
  cancel_order_success: "Order berhasil dibatalkan.",
  create_order_success: "Order request berhasil dibuat.",
  pick_job_failed: "Gagal mengambil job.",
  cancel_order_failed: "Gagal membatalkan order.",
  create_order_failed: "Gagal membuat order request.",
  reset: "Reset",

  please_choose_order_detail: "Mohon pilih order detail terlebih dahulu",
  track_fetch_failed: "Gagal mengambil data riwayat",
  copy_url: "Salin URL",
  url_copied: "URL berhasil disalin",
  url_copy_failed: "Gagal menyalin URL",

  profit_loss_title: "Lihat Profit and Loss",
  order_date: "Tanggal Pemesanan",
  total_cost: "Total Cost",
  total_revenue: "Total Revenue",
  total_profit_loss: "Total Profit Loss",
  bulk_print: "Cetak Massal",
  activity: "Aktivitas",

  btn_create_fordrive: "Buat akun fordrive",
  invoice_vendor: "Vendor Invoice",
  invoice: "Invoice",
  invoice_customer_pl: "Customer Invoice",

  ordertrucking_pickuptime: "Waktu Pengambilan",
  dynamic_column: "Kolom Dinamis",
  btn_apply:"Terapkan",
  btn_merge:"Gabung",
  ref_number:"Nomor Referensi",
  note:"Catatan",
  invoice_note:"Catatan Invoice",
  company: "Company",
  orderno: "Nomor Order",
  order_by: "Dipesan Oleh",

  origin_pic: "PIC Asal",
  origin_phone: "Nomor Telepon Asal",
  destination_pic: "PIC Tujuan",
  destination_phone: "Nomor Telepon Tujuan",

  transport_type: "Transport Type",

  vehicle_type: "Tipe Kendaraan",
  max_length: "Panjang Maksimal",
  max_width: "Lebar Maksimal",
  max_height: "Tinggi Maksimal",
  max_weight: "Berat Maksimal",
  is_show: "Ditampilkan",
  is_trailer: "Trailer",
  add_vehicle_type: "Tambah Vehicle Type",
  edit_vehicle_type: "Ubah Vehicle Type",

  order_detail: "Detail Pesanan",
  qty: "Jumlah",
  driver_name: "Nama Supir",
  fleet_name: "Nama Kendaraan",
  customer_name: "Nama Customer",
  valid_date: "Tanggal Valid",
  cost_number: "Nomor Beli",
  revenue_number: "Revenue Number",
  sell_number: "Nomor Jual",
  valid_start: "Valid Start",
  valid_end: "Valid End",
  pricing: "Pricing",
  add_pricing: "Tambah Harga",
  pricing_no: "Nomor Harga",
  origin_location: "Lokasi Asal",
  destination_location: "Lokasi Tujuan",
  move_type: "Move Type",
  load_type: "Load Type",
  warning_daterange: "Start date harus lebih awal dari finish date",
  cost_amount: "Harga Beli",
  cost_total_amount: "Total Harga Beli",
  revenue_amount: "Revenue Amount",
  revenue_total_amount: "Revenue Total Amount",
  sell_amount: "Harga Jual",
  sell_total_amount: "Total Harga Jual",
  add_detail: "Add Detail",
  freight_element: "Freight Element",
  vat: "Vat",
  cost_vat: "PPN Beli",
  sell_vat: "PPN Jual",
  edit_detail: "Edit Detail",
  currency: "Mata Uang",
  add_success_text:"Data berhasil ditambahkan! Apakah anda ingin menambahkan detail?",
  pricing_detail: "Detail Harga",
  total: "Total",
  is_manual: "Manual",
  
  loading_list: "Loading List",
  btn_add_loading_list: "Add Loading List",
  btn_edit_loading_list: "Edit Loading List",
  loading_list_no: "Loading List Number",
  loading_list_date: "Loading List Date",
  loading_list_detail: "Loading List Detail",

  cargo_list: "Cargo List",
  btn_add_cargo_list: "Add Cargo List",
  btn_edit_cargo_list: "Edit Cargo List",
  cargo_list_no: "Cargo List Number",
  cargo_list_date: "Cargo List Date",

  order_detal: "Detail Order",
  origin_city: "Kota Asal",
  destination_city: "Kota Tujuan",
  ref_no: "No. Referensi",
  cargo_type: "Tipe Kargo",
  voucher_code: "Kode Voucher",
  premi_amount: "Jumlah Premi",
  commodity_amount: "Jumlah Komoditas",

  package: "Paket",
  commodity: "Komoditas",
  length: "Panjang",
  width: "Lebar",
  height: "Tinggi",
  weight: "Berat",
  volume: "Volume",
  cargo_desc: "Deskripsi Kargo",
  cargo: "Kargo",

  send_to_fast: "Kirim ke FAST",
  fast_tariff_not_configured: "Tarif Rute belum di setup di FAST, silahkan hubungi admin FAST untuk melakukan setup tarif rute anda",
  city: "Kota", 
  origin_address: "Alaman Asal",
  destination_address: "Alamat Tujuan",
  origin_province: "Province Asal",
  destination_province: "Province Tujuan",
  address_detail: "Detail Alamat",
  origin_address_detail: "Origin Address Detail",
  destination_address_detail: "Destination Address Detail",

  confirm_customer_pic: "Apakah anda yakin melanjutkan perubahan data tanpa melengkapi data PIC Customer ?"
};

export default indonesiaWords;
